import Flickity from "flickity";

class Carousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carousel = self.elem.querySelector('[data-carousel]');
    }

    init() {
        let self = this;

        // Flickity options
        let flktyOptions = {
            contain: false,
            draggable: true,
            wrapAround: true,
            pageDots: true,
            prevNextButtons: true,
            autoPlay: false,
            cellAlign: 'center',
            initialIndex: 0,
            imagesLoaded: true,
            setGallerySize: self.elem.dataset.setGallerySize !== 'false',
        };

        // Initialise Flickity
        const flkty = new Flickity(self.carousel, flktyOptions);

        // Re-layout after all images have loaded to fix cells that appear blank on first load
        window.addEventListener('load', () => flkty.resize());
    }
}

export default Carousel;